import styled from "styled-components"
import React from "react"
import {
    ChevronDownIcon,
    CrossIcon,
    CogIcon,
} from "client/components"

const timeout = 300

export const ListTitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
`
export const LabelWrapper = styled.div<{
    collapsed: boolean
}>`
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 20px 15px 0;
    border: 1px solid ${(props) => props.theme.rrsLabelBorderColor};
    border-radius: 5px;
    max-height: ${(props) => (props.collapsed ? "50px" : "100%")};
    overflow: hidden;
    transition: max-height ${timeout}ms;

    &:last-child {
        margin-bottom: 15px;
    }
`
export const LabelDeleteButton = styled.div`
    position: absolute;
    top: 14px;
    right: 25px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.rrsDeleteButtonColor};
    transition: ${(props) => props.theme.defaultTransition};
    cursor: pointer;

    &:hover {
        color: ${(props) => props.theme.rrsDeleteButtonColorHover};
    }
`


interface CollapseButtonProps extends React.HTMLAttributes<HTMLDivElement> {
    collapsed: boolean
}
const CollapseButtonWrapper = styled.div<CollapseButtonProps>`
    position: absolute;
    top: ${(props) => (props.collapsed ? "14px" : "12px")};
    left: ${(props) => (props.collapsed ? "10px" : "12px")};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    color: ${(props) => props.theme.rrsCollapseButtonColor};
    transform: ${(props) => (props.collapsed ? "rotate(-90deg)" : "rotate(0deg)")};
    transition: ${(props) => props.theme.defaultTransition};
`
export const CollapseButton = (props: CollapseButtonProps) => (
    <CollapseButtonWrapper {...props}>
        <ChevronDownIcon />
    </CollapseButtonWrapper>
)


const NestedCategoryButtonWrapper = styled.div`
    height: 20px;
    display: flex;
    align-items: center;
    user-select: none;
    cursor: pointer;
    color: ${(props) => props.theme.rrsNestedCategoryButtonColor};
    transition: ${(props) => props.theme.defaultTransition};

    &:hover {
        color: ${(props) => props.theme.rrsNestedCategoryButtonHoverColor};
        transition: ${(props) => props.theme.defaultTransition};
    }
`
export const NestedCategoryDeleteButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <NestedCategoryButtonWrapper
        style={{ fontSize: "16px", transform: "translateX(7px)" }}
        {...props}
    >
        <CrossIcon />
    </NestedCategoryButtonWrapper>
)
export const NestedCategoryOptionsButton = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <NestedCategoryButtonWrapper
        style={{ fontSize: "18px" }}
        {...props}
    >
        <CogIcon />
    </NestedCategoryButtonWrapper>
)
